import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";

/*
 * Menu Management Services
 * !== 메뉴 관리 서비스 ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */

export const BASE = {
    path: `${ptlEnvs.base}/ptl/scrn`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/ptl/scrn/scrn-mgmt`,
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    osci0104004q: `${BASE.path}/osci0104004q`, // Select. Screen List !== 화면 목록 조회 ==!
    osci0104005s: `${BASE.path}/osci0104005s`, // Create. Screen Info !== 화면 정보 생성 ==!
    osci0104006s: `${BASE.path}/osci0104006s`, // Save. Screen Info !== 화면 정보 저장 ==!
};

export const PGEUIDS = {
    osci0104004q: "osci0104004q", // Select. Screen List !== 화면 목록 조회 ==!
    osci0104005s: "osci0104005s", // Create. Screen Info !== 화면 정보 생성 ==!
    osci0104006s: "osci0104006s", // Save. Screen Info !== 화면 정보 저장 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // View Screen List !== 화면 목록 조회 ==!
    getScrnList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, { params: comnUtils.toGetParams(data) });
    },
    // View Screen List By Menu Link !== 메뉴연결을 위한 화면 목록 조회 ==!
    getScrnListByMenuLink: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/${data.menuId}/menuLink?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams({ bsopClsfCd: data.bsopClsfCd, ptlTpCd: data.ptlTpCd }),
        });
    },

    // View Screen Detail !== 화면 상세 조회 ==!
    getScrnDtl: (scrnId: any) => {
        console.log(`${BASE.api}/${scrnId}`);
        console.log(`${BASE.api}/${scrnId}`);
        console.log(`${BASE.api}/${scrnId}`);
        console.log(`${BASE.api}/${scrnId}`);
        return api.get(`${BASE.api}/${scrnId}`);
    },

    // Save screen details !== 화면 상세정보 저장 ==!
    saveScrnDtl: (data: any) => api.post(`${BASE.api}`, { ...data }),

    // Delete screen details !== 화면 상세정보 삭제 ==!
    deleteScrnDtl: (scrnId: any) => api.delete(`${BASE.api}/${scrnId}`),
};

export const SF_SCRN_MGMT_SRCH: TFormSchema = {
    id: "form_scrnMgmtSrch",
    schema: {
        bsopClsfCd: {
            required: true,
            type: "select",
            label: "L_BSOP_CLSF_CD",
            area: "comnCd",
            comnCd: "OSC0088",
            select: false,
            excludes: ["COM"],
            defaultValue: "OSC",
        },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "OSC0095",
            excludes: ["B", "I", "E"],
            defaultValue: "O",
        },
        scrnId: { type: "text", label: "L_SCRN_ID" },
        scrnNm: { type: "text", label: "L_SCRN_NM" },
    },
};

export const SF_SCRN_MGMT: TFormSchema = {
    id: "form_scrnMgmt",
    schema: {
        scrnId: {
            required: true,
            type: "text",
            label: "L_SCRN_ID",
            letterCase: "lower",
            placeholder: "aaaa0000000a",
            pattern: { value: /[a-z]{3}[i|e|o][0-9]{4}[0-9]{3}[q|s]/, message: "msg.osc.00202" },
        },
        scrnDefnDocId: { required: true, readOnly: true, type: "text", label: "L_SCRN_DEFN_DOC_ID" },
        scrnNm: { type: "text", label: "L_SCRN_NM" },
        scrnUrlAddr: { required: true, type: "text", label: "L_SCRN_URL_ADDR" },
        bsopClsfCd: {
            required: true,
            type: "select",
            label: "L_BSOP_CLSF_CD",
            area: "comnCd",
            comnCd: "OSC0088",
            excludes: ["COM"],
            defaultValue: "OSC",
        },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "OSC0095",
            excludes: ["B", "I", "E"],
            defaultValue: "O",
        },
        scrnNmKO: { required: true, type: "text", label: "L_SCRN_NM_KOR" },
        scrnNmEN: { required: true, type: "text", label: "L_SCRN_NM_EN" },
        scrnNmTZ: { type: "text", label: "L_SCRN_NM_TZ" },
        scrnDescKO: { type: "text", label: "L_SCRN_DESC_KOR" },
        scrnDescEN: { type: "text", label: "L_SCRN_DESC_EN" },
        scrnDescTZ: { type: "text", label: "L_SCRN_DESC_TZ" },
    },
};

export const SG_SCRN_LIST: TGridSchema = {
    id: "grid_scrnList",
    options: { index: true, pagination: "out", height: 400 },
    head: [
        { cells: [{ header: "L_SCRN_ID", binding: "scrnId", width: "10%" }] },
        { cells: [{ header: "L_SCRN_NM", binding: "scrnNm", width: "20%" }] },
        { cells: [{ header: "L_SCRN_URL_ADDR", binding: "scrnUrlAddr", width: "30%" }] },
        { cells: [{ header: "L_SCRN_DESC", binding: "scrnDesc", width: "*" }] },
        { show: false, cells: [{ binding: "chkYn" }] },
        { show: false, cells: [{ binding: "menuCnctYn" }] },
        { show: false, cells: [{ binding: "menuId" }] },
    ],
    body: [
        { cells: [{ binding: "scrnId" }] },
        { cells: [{ binding: "scrnNm", align: "left" }] },
        { cells: [{ binding: "scrnUrlAddr", align: "left" }] },
        { cells: [{ binding: "scrnDesc", align: "left" }] },
        { cells: [{ binding: "chkYn" }] },
        { cells: [{ binding: "menuCnctYn" }] },
        { cells: [{ binding: "menuId" }] },
    ],
};

export const SG_SCRN_LANG_LIST: TGridSchema = {
    id: "grid_scrnLangList",
    options: { checkbox: true, height: 123 },
    head: [
        { cells: [{ header: "L_LANG_CD", binding: "langCd", width: 100 }] },
        { cells: [{ header: "L_SCRN_NM", binding: "scrnNm", width: 150 }] },
        { cells: [{ header: "L_SCRN_DESC", binding: "scrnDesc", width: "*" }] },
    ],
    body: [
        {
            cells: [
                {
                    binding: "langCd",
                    required: true,
                    edit: true,
                    letterCase: "upper",
                    placeholder: "AA",
                    mask: [/[A-Z]/, /[A-Z]/],
                },
            ],
        },
        { cells: [{ binding: "scrnNm", required: true, edit: true, align: "left" }] },
        { cells: [{ binding: "scrnDesc", edit: true, align: "left" }] },
    ],
};
